<template>
  <div v-if="isAuth" class="flex overflow-hidden bg-gray-100">
    <Sidebar />
    <Main />

    <Notification
      v-for="(item, index) in notifications"
      v-bind:item="item"
      v-bind:index="index"
      v-bind:key="index"
    />
  </div>
  <Login v-else />
</template>

<script>
import Sidebar from "./Sidebar";
import Main from "./Main";
import Login from "@/views/Login.vue";
import Notification from "@/components/elements/Notification.vue";

import { mapState } from "vuex";

export default {
  name: "Layout",
  components: {
    Sidebar,
    Main,
    Login,
    Notification
  },
  computed: {
    isAuth() {
      return this.$store.state.user.loggedIn;
    },
    ...mapState(["notifications"])
  }
};
</script>

<style scoped></style>
